import React from 'react';
import Route from 'react-router/lib/Route';
import { MAILCHIMP_REDIRECT_PATH } from './main/settings/integrations/Mailchimp/constants';
import { requireAuthAndMailchimpPermissions } from './auth/routerHooks';

export default store => (
  <Route path={MAILCHIMP_REDIRECT_PATH} onEnter={requireAuthAndMailchimpPermissions(store)} />
);
